export const ALLOWED_FILE_EXTENSIONS = [
  ".jpg", ".jpeg", ".png", ".pdf",
  ".docx", ".xlsx", ".pptx", ".txt",
  ".doc", ".xls", ".ppt"
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export const MAX_FILE_SIZE_TEXT = "10MB";

export const ALLOWED_FILE_TYPES_FOR_INPUT = ALLOWED_FILE_EXTENSIONS.join(',');
